
<div class="flow-tour-step">
	<div class="flow-tour-body">
		<slot />
	</div>
	<div class="flow-tour-footer">
		<slot name="footer" />
	</div>
	<div data-popper-arrow class="flow-step-arrow" />
</div>
